<div>
    <h2 class="headline-05 my-4">Titular</h2>
    <mat-radio-group [(ngModel)]="selectedPatient">
        <div class="flex items-center border rounded-lg px-4 py-2 patient-card">
            <div class="flex items-center gap-2">
                <mat-icon>person</mat-icon>
                <div>
                    <p class="font-semibold">{{ nameOwner }}</p>
                    <p class="paragraph-small">Titular</p>
                </div>
            </div>
            <mat-radio-button class="ml-auto" value="titular"></mat-radio-button>
        </div>
    </mat-radio-group>
</div>

<!-- DEPENDIENTES OCULTOS TEMPORALMENTE
<div *ngIf="dependent.length > 0">
    <h2 class="headline-03 mt-4 mb-1">Dependientes</h2>
    <mat-radio-group [(ngModel)]="selectedPatient" class="space-y-2 block">
        <div *ngFor="let dep of dependent; let i = index"
             [class.hidden]="!showAllDependents && i > 0"
             class="flex items-center border rounded-lg px-4 py-2 patient-card">
            <div class="flex items-center gap-2">
                <mat-icon>person</mat-icon>
                <div>
                    <p class="paragraph-medium">{{ dep.name }}</p>
                    <p class="paragraph-small">{{ dep.catalog.description }}</p>
                </div>
            </div>
            <mat-radio-button class="ml-auto" [value]="dep.name"></mat-radio-button>
        </div>
    </mat-radio-group>

    <button *ngIf="dependent.length > 1"
            class="dependents-toggle-btn"
            (click)="toggleDependents()">
        <p>&nbsp;{{ showAllDependents ? 'Ocultar dependientes' : 'Ver más dependientes' }}</p>
        <mat-icon>{{ showAllDependents ? 'remove' : 'add' }}</mat-icon>
    </button>
        <div
      class="w-full mt-3 border border-[#0E365A] text-[#0E365A] rounded-[16px] cursor-pointer py-3 px-4 flex items-center justify-between hover:bg-gray-50"
       (click)="addNewDependent()">
      <span>Agregar nuevo dependiente</span>
      <mat-icon>add</mat-icon>
    </div>
</div>
FIN DEPENDIENTES OCULTOS TEMPORALMENTE -->

<div>
    <h2 class="headline-03 mt-4 mb-1">Información del estudio</h2>
    <div class="space-y-2">
        <mat-form-field class="w-full" appearance="outline">
            <mat-icon matPrefix>science</mat-icon>
            <input
                matInput
                placeholder="Selecciona estudio médico..."
                [matAutocomplete]="studyAutocomplete"
                [(ngModel)]="studySearchText"
                (ngModelChange)="onStudySearchChange($event)"
                (focus)="onStudyFocus($event)"
                (keypress)="onStudyKeyPress($event)">
            <mat-autocomplete #studyAutocomplete="matAutocomplete" (optionSelected)="onStudySelected($event)">
                <mat-option *ngFor="let study of filteredStudies" [value]="study.description">
                    <div>
                        <div class="font-medium">{{ study.description }}</div>
                    </div>
                </mat-option>
            </mat-autocomplete>
        </mat-form-field>

        <div *ngIf="selectedStudy" class="w-full relative">
            <mat-form-field class="w-full" appearance="outline">
                <mat-icon matPrefix>location_on</mat-icon>
                <input
                    matInput
                    placeholder="Buscar por dirección, código postal, ciudad, colonia..."
                    #addressInput
                    [(ngModel)]="locationSearchText"
                    (input)="onLocationSearch($event)"
                    (focus)="onLocationFocus()">
                <mat-icon *ngIf="locationSearchText" matSuffix class="cursor-pointer" (click)="clearLocationSearch()">close</mat-icon>
            </mat-form-field>

            <div *ngIf="showLocationSuggestions" class="absolute -mt-4 left-0 right-0 bg-white border border-gray-300 rounded-lg shadow-lg max-h-48 overflow-y-auto z-50">
                <div class="p-2 hover:bg-gray-100 cursor-pointer border-b" (click)="selectCurrentLocation()">
                    <div class="flex items-center gap-2">
                        <mat-icon class="text-blue-600 text-sm">my_location</mat-icon>
                        <span class="text-sm">Mi ubicación actual</span>
                    </div>
                </div>
                <div *ngFor="let suggestion of googleSuggestions"
                     class="p-2 hover:bg-gray-100 cursor-pointer"
                     (click)="selectGoogleLocation(suggestion)">
                    <div class="font-medium text-sm">{{ suggestion.description }}</div>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Modal de carga de laboratorios -->
<div *ngIf="isSearchingLaboratories" class="fixed inset-0 flex items-center justify-center z-50" style="background-color: rgba(0, 0, 0, 0.4);">
    <div class="bg-white rounded-lg" style="padding: 30px; text-align: center; max-width: 400px;">
        <div style="display: flex; flex-direction: column; align-items: center; gap: 10px;">
            <div style="width: 60px; height: 60px; border-radius: 50%; display: flex; align-items: center; justify-content: center; background-color: #D9E7F3; color: #003746;">
                <mat-icon style="font-size: 32px; width: 32px; height: 32px; animation: spin 1s linear infinite;">refresh</mat-icon>
            </div>
            <h3 style="margin: 0; color: #003746; font-weight: 600; font-size: 20px;">Buscando laboratorios</h3>
            <p style="margin: 0; color: #3D4E5F; font-size: 14px; line-height: 1.5; max-width: 300px;">Estamos buscando los laboratorios más cercanos a tu ubicación...</p>
        </div>
    </div>
</div>

<style>
@keyframes spin {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}
</style>

<div *ngIf="selectedLaboratoryData" id="selected-laboratory-section">
    <h2 class="headline-03 mt-4 mb-1">Laboratorio seleccionado</h2>
    <div class="flex items-center border rounded-lg px-4 py-2 bg-green-50 border-green-200">
        <mat-icon class="text-green-600 mr-3">check_circle</mat-icon>
        <div class="flex-1">
            <p class="font-medium text-green-800">{{ selectedLaboratoryData.name }}</p>
            <p class="text-sm text-green-700">{{ selectedLaboratoryData.address }}</p>
            <p class="text-xs text-green-600">{{ selectedLaboratoryData.city }}, {{ selectedLaboratoryData.state }}</p>
        </div>
    </div>
</div>

<div>
    <h2 class="headline-03 mt-4 mb-1">Método de envío</h2>
    <div class="flex items-center gap-2 mb-2">
        <div class="rounded-full p-1" style="background-color: #052631;">
            <img src="assets/images/icons/whats.png" alt="WhatsApp" class="w-4 h-4">
        </div>
        <p class="paragraph-medium">WhatsApp</p>
    </div>
    <p class="paragraph-small">Tu expediente se enviará a través de WhatsApp al número *** **** {{ phoneOwner.slice(-3) }}.</p>
</div>

<button
    class="submit-btn"
    [class.disabled]="!canRequestCheckup()"
    [disabled]="!canRequestCheckup()"
    (click)="requestCheckup()">
    Solicitar
</button>
